import axios from 'axios';

export default class ImportSiteApi {
  constructor(baseUrl, config) {
    this.baseUrl = baseUrl;
    this.config = config;
  }

  postImportSiteFile(formData) {
    const config = {
      ...this.config,
      headers: {
        ...this.config.headers,
        'content-type': 'multipart/form-data',
      },
    };
    //config.headers.Authorization = "Bearer " + cookie.getCookie('access_token');
    const url = `${this.baseUrl}/api/sitemaster/import`;

    return new Promise((resolve, reject) => {
      axios
        .post(url, formData, config)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  }
}



// WEBPACK FOOTER //
// ./src/pages/importsite/api/ImportSiteApi.js